import { reactLocalStorage } from 'reactjs-localstorage';

import Const from '../util/Constants';

class KanbanController {

  static MainView = 0;
  static Public = 1;
  static Role = 2;
  static User = 3;

  static getViews = model => {
    const kanbanViewsObj = reactLocalStorage.getObject(Const.KanbanViews);
    let kanbanViews = Object.values(kanbanViewsObj);
    const user = reactLocalStorage.getObject(Const.LoggedInUser);
    // const name = `All ${Display.ModulLabelValue(model)}`;
    kanbanViews = [ ...kanbanViews.filter(kanbanView => {
        if(kanbanView.model !== model) {
          return false; 
        }
        if(kanbanView.type === KanbanController.MainView) {
          return (!kanbanView.role && !kanbanView.users)
            || (kanbanView.roles && kanbanView.roles.includes(Const.Opt + user.role + Const.Opt))
            || (kanbanView.users && kanbanView.users.includes(Const.Opt + user.user_id + Const.Opt));
        } 
        if(kanbanView.type === KanbanController.Public) {
          return true;
        }
        if(kanbanView.type === KanbanController.Role) {
          return kanbanView.roles && kanbanView.roles.includes(Const.Opt + user.role + Const.Opt);
        } 
        if(kanbanView.type === KanbanController.User) {
          return kanbanView.users && kanbanView.users.includes(Const.Opt + user.user_id + Const.Opt);
        }
        return false;
      })
    ];

    return kanbanViews;
  }
}
export default KanbanController;